import { MatchingRecord } from '@eluve/utils';

import { UserUploadStatusEnum } from './types';

export const UserUploadStatusLookup = {
  AVAILABLE: 'AVAILABLE',
  DELETED: 'DELETED',
  PENDING_DELETION: 'PENDING_DELETION',
  PENDING_UPLOAD: 'PENDING_UPLOAD',
  PRE_PROVISIONED: 'PRE_PROVISIONED',
  UPLOAD_ERROR: 'UPLOAD_ERROR',
  CANCELLED: 'CANCELLED',
} as const satisfies MatchingRecord<UserUploadStatusEnum>;
